<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M12.9008 2.99998C12.9008 2.50292 12.4978 2.09998 12.0008 2.09998C11.5037 2.09998 11.1008 2.50292 11.1008 2.99998V14.0769C11.1008 14.5739 11.5037 14.9769 12.0008 14.9769C12.4978 14.9769 12.9008 14.5739 12.9008 14.0769V2.99998Z"
    />
    <path
      d="M12.0008 21C12.9567 21 13.7316 20.2251 13.7316 19.2692C13.7316 18.3133 12.9567 17.5384 12.0008 17.5384C11.0449 17.5384 10.27 18.3133 10.27 19.2692C10.27 20.2251 11.0449 21 12.0008 21Z"
    />
  </svg>
</template>
